import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { MainserviceService } from 'src/app/mainservice.service';
import { addVideo, addVideoSuccess, deleteVideo, deleteVideoSuccess, loadVideos, loadVideosFailure, loadVideosSuccess } from '../action/video.actions';


@Injectable()
export class VideoEffects {
  constructor(private actions$: Actions, private videoService: MainserviceService) {}

  // Load Videos
  loadVideos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadVideos),
      mergeMap(() =>
        this.videoService.getVideo().pipe(
          map(video => loadVideosSuccess({ video })),
          catchError(error => of(loadVideosFailure({ error: error.message })))
        )
      )
    )
  );

  // Add Video
  addVideo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addVideo),
      mergeMap(action =>
        this.videoService.addVideo(action.video).pipe(
          map(video => addVideoSuccess({ video })),
          catchError(error => of(loadVideosFailure({ error: error.message })))
        )
      )
    )
  );

  // Update Video
//   updateVideo$ = createEffect(() =>
//     this.actions$.pipe(
//       ofType(VideoActions.updateVideo),
//       mergeMap(action =>
//         this.videoService.updateVideo(action.video).pipe(
//           map(video => VideoActions.updateVideoSuccess({ video })),
//           catchError(error => of(VideoActions.loadVideosFailure({ error: error.message })))
//         )
//       )
//     )
//   );

  // Delete Video
  deleteVideo$=createEffect(()=>
    this.actions$.pipe(
      ofType(deleteVideo),
      mergeMap(action=>
        this.videoService.deleteVideoByID(action.id).pipe(
          map((res:any)=>deleteVideoSuccess({id:action.id}))
        )
      )

    )
  );
}
